import { AccountView } from "@bitwarden/web-vault/app/models/view/account/account.view";
import { SyncStatusView } from "@bitwarden/web-vault/app/models/view/sync-status/sync-status.view";
import { AccountType } from "@bitwarden/web-vault/app/models/types/account.types";
import { InstitutionView } from "@bitwarden/web-vault/app/models/view/institution/institution.view";

/**
 * banded : if true then the calculation are made tax-like. use the rate for upto range amount. ex you have 100 000 dollars and first range is 10 000 then use rate for up to 10 000
 * if false use rate for 100 000
 * */
export type InstitutionInterest = {
  range: number;
  banded: boolean;
  rate: number;
  symbol: string;
  last_updated: string;
  condition_intrinsic_desc: string;
  condition_action_desc: string;
};

/** account types of institution */
/** deprecated type file
 *  use institution.view.ts -> InstitutionAccountView
 *  same with BicType and SwiftType
 * */
// export type InstitutionAccount = {
//   id: string;
//   name: string;
//   institutionName?: string;
//   interestRates: InstitutionInterest[];
//   useForScenarioBestRate?: string;
//   link?: string;
// };

export type BicType = {
  bankCode: string;
  countryCode: string;
  locationCode: string;
};

export type SwiftType = {
  bankCode: string;
  countryCode: string;
  locationCode: string;
  branchCode: string;
};

/** on gloss account aka book-renderer , we need to retrieve the link between gloss account and real account to get the interest rates and all */
export type InstitutionAccountLink = {
  institutionId: string;
  institutionAccountId: string;
};

export type InstitutionGroup = { institutionId: string; accountViews: AccountView[] };

export type InstitutionOrigin = `${InstitutionOriginEnum}`;

export enum InstitutionOriginEnum {
  manual = "manual",
  auto = "auto",
  autoFetch = "autoFetch",
}

export type InstitutionTableView = {
  original: InstitutionView;
  type: InstitutionOrigin;
  country: string;
  id: string;
  dragHandle: boolean;
  rightChevron: boolean;
  institutionCode: string;
  name: string;
  full_logo_url: string;
  square_logo_url: string;
};
